import { Title, useGetIdentity, useTranslate } from 'react-admin'
import { Card, Typography } from '@mui/material'
import { MapDataOpacitySlider } from './components/map-data-opacity-slider';


export const SettingsPage = () => {
  //const translate = useTranslate();
  //const { data: identity, isPending: isPendingIdentity } = useGetIdentity();

  //console.log('Menu Identity', identity);

  return (
    <Card
      sx={{
        padding: '20px',
        marginTop: 2,
        marginBottom: '1em',
      }}
    >
      <Title title={'Settings'} />
      <Typography variant="h5" component="h2" gutterBottom>
        {'Map'}
      </Typography>
      <MapDataOpacitySlider />
      {/* <SimpleForm>
        <ThemeSwapper />
        <SelectTheme />
        <SelectLanguage />
        <SelectDefaultView />
      </SimpleForm> */}
    </Card>
  )
};
